import { IconUserCog, IconSquareRoundedPlus, IconClipboardList, IconInfoSquareRounded } from '@tabler/icons-react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { NavigationLink, NavigationLinksContext } from '#features/navigation'
import { ClientContext, clientMeQueryOptions } from '#entities/client'

interface ClientDataProviderProps {
  children?: React.ReactNode
}

export default function ClientDataProvider({ children }: ClientDataProviderProps) {
  const clientMeQuery = useSuspenseQuery(clientMeQueryOptions)
  const currentClient = clientMeQuery.data

  const clientNavigationLinks = useMemo<NavigationLink[]>(() => {
    // Client is not created yet, restricting navigation from profile page
    if (!currentClient) return []

    return [
      {
        icon: <IconInfoSquareRounded />,
        to: '/client/info',
        displayName: 'Информация',
      },
      {
        icon: <IconUserCog />,
        to: '/client/profile',
        displayName: 'Профиль',
      },
      {
        icon: <IconSquareRoundedPlus />,
        to: '/client/new-order',
        matches: ['/client/order-payment'],
        displayName: 'Новый заказ',
      },
      {
        icon: <IconClipboardList />,
        to: '/client/orders',
        matches: ['/client/orders/$id'],
        displayName: 'Заказы',
      },
    ]
  }, [currentClient])

  return (
    <NavigationLinksContext.Provider value={clientNavigationLinks}>
      <ClientContext.Provider value={currentClient}>{children}</ClientContext.Provider>
    </NavigationLinksContext.Provider>
  )
}
